var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"tc-page-header pb-8 max-w-screen-xl mx-auto sm:flex sm:justify-between sm:items-center px-6 sm:h-20"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }